import { useContext } from "react";
import AuthContext, { IAuthContextProps } from "./AuthContext";

const useAuthentication: () => IAuthContextProps = () => {
  return useContext(AuthContext);
};

export default useAuthentication;